import { AppEventSchema } from '@app/icare/events'
import { createIoTMqttListener } from '@pkg/sync/client'
import { createNanoEvents } from 'nanoevents'

export const reconnectEvents = createNanoEvents<{ reconnect: () => void }>()

export const eventsListener = createIoTMqttListener({
  schema: AppEventSchema,
  onReconnect: () => reconnectEvents.emit('reconnect'),
})

export const events = eventsListener.events
